<template>
  <div class="py-16">
    <h1 class="text-center mb-10">اطلاعات پرداخت</h1>
    <v-divider></v-divider>
    <v-row>
      <v-col cols="12" md="2" sm="3">
        <v-img
          contain
          class="re-rounded re-shadow mx-auto"
          elevation="10"
          width="250"
          :src="
            'https://dl.pirls.ir/app/bookcovers/' +
            this.$route.params.id +
            '.jpg'
          "
        />
      </v-col>
      <v-col cols="12" md="10" sm="9" class="pa-5">
        <div class="text-h6 mb-5">
          <v-icon class="ml-2">mdi-book-open-page-variant-outline</v-icon>
          <strong>نام کتاب: </strong>{{ book.title }}
        </div>
        <div class="text-h6 mb-5">
          <v-icon class="ml-2">mdi-cash</v-icon>
          <strong>قیمت کتاب: </strong>
          <number :number="book.price" unit="ریال"></number>
        </div>
        <v-alert icon="mdi-information-outline" prominent text color="accent">
          این خرید شامل استفاده <strong>نامحدود</strong> از متن، صوت و فیلم این
          کتاب به همراه سنجش، گزارشات و تقدیرنامه هر کتاب می باشد.
        </v-alert>
        <div v-if="!done" class="d-flex align-center">
          <div v-if="!discountCodeId" class="d-flex align-center">
            <v-text-field
              v-model="discountCode"
              label="کد تخفیف"
            ></v-text-field>
            <v-btn
              depressed
              class="mx-3"
              color="secondary"
              @click="applyDiscount"
              >اعمال کد تخفیف</v-btn
            >
          </div>
          <v-btn
            v-if="totalAmount == 0"
            depressed
            class="flex-fill"
            color="success"
            @click="active"
          >
            فعال سازی کتاب
          </v-btn>
          <v-btn
            v-else
            depressed
            class="flex-fill"
            color="primary"
            :loading="loading"
            :disable="loading"
            @click="pay"
          >
            پرداخت مبلغ:
            <number
              v-if="totalAmount"
              :number="totalAmount"
              unit="ریال"
            ></number>
            <number v-else :number="book.price" unit="ریال"></number>
          </v-btn>
        </div>
        <div v-else>
          <v-btn
            block
            depressed
            color="accent"
            router
            :to="`/Book/Get/${book._id}`"
            >مشاهده کتاب</v-btn
          >
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: "checkout-component",
  data() {
    return {
      book: {},
      loading: false,
      totalAmount: null,
      discountCode: "",
      discountCodeId: null,
      done: false
    };
  },
  created() {
    this.getBook();
  },
  methods: {
    getBook() {
      this.$api.get("/book/" + this.$route.params.id).then((res) => {
        this.book = res.data.book;
      });
    },
    applyDiscount() {
      this.$api
        .post("/discountCode", {
          code: this.discountCode
        })
        .then((res) => {
          const discountCode = res.data.discountCode;
          this.discountCodeId = discountCode._id;
          if (discountCode.percent != 0) {
            this.totalAmount =
              this.book.price - (this.book.price * discountCode.percent) / 100;
          }
          if (discountCode.price != 0) {
            this.totalAmount = this.book.price - discountCode.price;
          }
        })
        .catch((err) => {
          this.$store.commit("clearMessageState");
          this.$store.commit("setMessageState");
          this.$store.commit("setMessageType", "error");
          this.$store.commit("setMessage", err.response.data.error);
          // to TOP
          window.scrollTo(0, 0);
        });
    },
    active() {
      this.$api
        .post("/discountCode", {
          code: this.discountCode
        })
        .then((res) => {
          const discountCode = res.data.discountCode;
          if (!discountCode.used) {
            this.$api
              .post("/order/add", {
                book: this.$route.params.id,
                discountCode: this.discountCodeId,
                verify: true
              })
              .then(() => {
                this.$api
                  .post("/user/addBook", {
                    book: this.$route.params.id
                  })
                  .then(() => {
                    this.done = true;
                    this.$store.dispatch("checkUser");
                  })
                  .catch((err) => {
                    this.$store.commit("clearMessageState");
                    this.$store.commit("setMessageState");
                    this.$store.commit("setMessageType", "error");
                    this.$store.commit("setMessage", err.response.data.error);
                    // to TOP
                    window.scrollTo(0, 0);
                  });
              })
              .catch((err) => {
                this.$store.commit("clearMessageState");
                this.$store.commit("setMessageState");
                this.$store.commit("setMessageType", "error");
                this.$store.commit("setMessage", err.response.data.error);
                // to TOP
                window.scrollTo(0, 0);
              });
          } else {
            this.$store.commit("clearMessageState");
            this.$store.commit("setMessageState");
            this.$store.commit("setMessageType", "error");
            this.$store.commit("setMessage", "این کد تخفیف استفاده شده است");
          }
        })
        .catch((err) => {
          this.$store.commit("clearMessageState");
          this.$store.commit("setMessageState");
          this.$store.commit("setMessageType", "error");
          this.$store.commit("setMessage", err.response.data.error);
          // to TOP
          window.scrollTo(0, 0);
        });
    },
    pay() {
      this.loading = true;
      this.$api
        .post("/Order/add", {
          book: this.$route.params.id,
          discountCode: this.discountCodeId,
          amount: this.book.price
        })
        .then((res) => {
          location.replace(res.data.url);
        })
        .catch((err) => {
          this.$store.commit("clearMessageState");
          this.$store.commit("setMessageState");
          this.$store.commit("setMessageType", "error");
          this.$store.commit("setMessage", err.response.data.error);
          // to TOP
          window.scrollTo(0, 0);
        });
    }
  }
};
</script>
